import React, { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../../styles/global.css"; // Ensure global styles are imported if not done in gatsby-browser

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-black text-gray-200 font-sans selection:bg-maroon-600 selection:text-white flex flex-col">
      <Header />
      <main className={`grow min-h-[calc(100vh-400px)]`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
